<div class="number-input-component">
  <ion-button [disabled]="reservationState.disableNext" *ngIf="!isAsyaSoft" fill="clear" class="input-button"
    (click)="decrement()">
    <ion-icon name="remove-outline"></ion-icon>
  </ion-button>

  <span class="value">{{ value }}</span>

  <ion-button [disabled]="reservationState.disableNext" *ngIf="!isAsyaSoft" fill="clear" class="input-button"
    (click)="increment()">
    <ion-icon name="add-outline"></ion-icon>
  </ion-button>
</div>